/* KASTENKISTE · Anker-Sprünge mit Header-Versatz
   1) Links wie href="/#finder" oder href="#finder" scrollen sanft zum Abschnitt.
   2) Passende Header-Menüpunkte scrollen auf der Startseite zum jeweiligen Abschnitt
      (per Text erkannt), ohne das Store-Menü zu verändern.
   3) Nach einem unterbrechungsfreien Seitenwechsel (kk-player.js) werden die
      Abschnitts-Anker neu gesetzt. */
(function(){
  'use strict';
  var MAP={hero:'start',modellfinder:'finder',herz:'herzstueck',usp:'vorteile',story:'story',
    painpoints:'painpoints',kundengalerie:'kastenkistler',vergleich:'vergleich',dreiminuten:'ablauf',modelle:'modelle',
    banner:'abenteuer',video:'video',wege:'meinweg',galerie:'galerie',blogteaser:'blog',faq:'faq',cta:'kontakt'};
  var ORDER=['hero','modellfinder','painpoints','herz','usp','story','kundengalerie','vergleich','dreiminuten',
    'modelle','banner','video','wege','galerie','blogteaser','faq','cta'];
  /* Menü-Text (kleingeschrieben) → Abschnitt. Nur eindeutige Treffer. */
  var TEXTMAP=[
    {re:/kundenmeinung|kundenstimm|bewertung|meinung/,an:'kastenkistler'},
    {re:/galerie|echte boxen|abenteuer/,an:'galerie'},
    {re:/fragen|faq|häufige/,an:'faq'},
    {re:/kontakt/,an:'kontakt'},
    {re:/mein weg|dein weg|mietet|kaufen|selber bauen/,an:'meinweg'},
    {re:/^\s*startseite\s*$|^\s*home\s*$/,an:'start'}
  ];

  function istStart(){ return !!(document.body&&document.body.classList&&document.body.classList.contains('template-index')); }
  function keyOf(sec){ var id=(sec.id||'').replace(/^shopify-section-/,''); if(id.indexOf('__')>=0)id=id.split('__').pop(); return id; }

  function ankerSetzen(){
    var host=document.getElementById('kk-inhalt'); if(!host)return;
    var list=host.querySelectorAll(':scope > .shopify-section');
    if(!list.length)list=host.querySelectorAll('.shopify-section');
    Array.prototype.forEach.call(list,function(s,i){
      var k=keyOf(s);
      if(!MAP[k] && ORDER[i])k=ORDER[i];
      if(MAP[k])s.setAttribute('data-anker',MAP[k]);
    });
  }

  function stickyH(el){ if(!el)return 0; var p=(window.getComputedStyle?getComputedStyle(el).position:''); return (p==='fixed'||p==='sticky')?el.getBoundingClientRect().height:0; }
  function headerH(){ return stickyH(document.querySelector('.kk-topbar')) + stickyH(document.querySelector('.kk-head')); }
  function ziel(name){ return document.querySelector('[data-anker="'+name+'"]') || document.getElementById(name); }
  function hin(el){
    if(!el)return;
    var y=el.getBoundingClientRect().top+(window.pageYOffset||document.documentElement.scrollTop)-headerH()-12;
    if(y<0)y=0;
    try{ window.scrollTo({top:y,behavior:'smooth'}); }catch(e){ window.scrollTo(0,y); }
  }
  function hashName(href){ var i=href.indexOf('#'); return i>=0?href.slice(i+1):''; }
  function schliesseMenu(){
    var nav=document.querySelector('[data-kk-nav]');
    if(nav){ nav.classList.remove('offen','open','aktiv');
      var b=document.querySelector('[data-kk-burger]'); if(b)b.setAttribute('aria-expanded','false'); }
    document.documentElement.classList.remove('nav-offen');
    if(document.body)document.body.classList.remove('nav-offen','menu-open');
  }
  function spring(el,name){
    schliesseMenu();
    setTimeout(function(){ hin(el); },20);
    try{ if(name&&history.replaceState)history.replaceState(null,'','#'+name); }catch(e){}
  }

  /* Pfad-Vergleich robust: absolute wie relative URLs auf dieselbe Seite erkennen */
  function gleicheSeite(href){
    try{ var u=new URL(href, window.location.href);
      return u.origin===window.location.origin && u.pathname===window.location.pathname;
    }catch(e){
      var pfad=href.split('#')[0];
      return !(pfad && pfad!=='/' && pfad!==window.location.pathname);
    }
  }

  document.addEventListener('click',function(e){
    var a=e.target&&e.target.closest?e.target.closest('a[href]'):null; if(!a)return;
    var href=a.getAttribute('href')||'';
    /* 1) echte Anker-Links auf DERSELBEN Seite */
    if(href.indexOf('#')>=0){
      var n=hashName(href);
      if(n && gleicheSeite(href)){
        var el=ziel(n);
        if(el){ e.preventDefault(); spring(el,n); return; }
      }
    }
    /* 2) Header-Menüpunkte per Text (nur Startseite) */
    if(istStart() && a.closest && (a.closest('[data-kk-nav]')||a.closest('.kk-head'))){
      var t=(a.textContent||'').toLowerCase();
      for(var i=0;i<TEXTMAP.length;i++){
        if(TEXTMAP[i].re.test(t)){
          var el2=ziel(TEXTMAP[i].an);
          if(el2){ e.preventDefault(); spring(el2,TEXTMAP[i].an); }
          return;
        }
      }
    }
  },true);

  function start(){
    ankerSetzen();
    if(window.location.hash&&window.location.hash.length>1){
      var n=window.location.hash.slice(1);
      setTimeout(function(){ var el=ziel(n); if(el)hin(el); },250);
    }
  }
  /* Nach unterbrechungsfreiem Seitenwechsel: Anker neu setzen (kk-player.js scrollt selbst) */
  document.addEventListener('kk:seite-gewechselt',function(){ ankerSetzen(); });

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);
  else start();
})();
